// plugins/confirm.js
import { createApp, h, ref } from 'vue';
import ConfirmDialog from '../../components/Reader/includes/ConfirmDialog.vue';

export default {
    install( app ) {

        const container = document.createElement('div');
        document.body.appendChild( container );

        const dialogApp = createApp({
            setup() {
                const dialog = ref( null );
                app.config.globalProperties.$confirm = ( message, okText = 'Confirm' ) => {
                    return dialog.value?.open( message, okText );
                };
                return () => h( ConfirmDialog, { ref: dialog } );
            }
        });

        dialogApp.mount( container );
    }
};